import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import Radium from 'radium'
import ReactTable from 'react-table'
import CsvDownload from "react-json-to-csv";

import { startWatchingJobsHistory, stopWatchingJobsHistory } from './../../../../actions/Manager'
import { startWatchingOrganization, stopWatchingOrganization } from './../../../../actions/Admin'
import { getJobHistoryArray } from './../../../../selectors/Manager'

import TEHelmet from './../../../../component/TEHelmet'

import PanelWrapper from './../../../../component/Layout/PanelWrapper'
import Panel from './../../../../component/Layout/Panel'

import { tableColumns } from './tableConfigs'
import { convertToDateShort, convertToDateTimeShort, customTableFilter } from './../../../../helpers'
import styles from './styles'

class History extends Component {
	componentDidMount() {
		const { userModel, startWatchingJobsHistory, startWatchingOrganization } = this.props
		startWatchingJobsHistory(userModel.organizationUID)
		startWatchingOrganization(userModel.organizationUID)
	}
	componentWillUnmount() {
		this.props.stopWatchingJobsHistory()
		this.props.stopWatchingOrganization()
	}

	render() {
		const meta = {
			title: 'Rittal | Job History',
			description: '',
		}
		const { jobArray, organizationUsers } = this.props
		let exportArray = [];
		let assignedToString
		let assignedToArray
		jobArray.forEach((d) => {
			assignedToString = ' -- '
			if (d.assignedTo && organizationUsers) {
				assignedToArray = []
				for (const userUID in d.assignedTo) {
					const user = organizationUsers[userUID]
					if (user && (user.firstName || user.lastName)) {
						const { firstName, lastName } = user
						const displayName = `${firstName || ''} ${lastName || ''}`.trim()
						assignedToArray.push(`${displayName}`)
					}
				}
				assignedToString = assignedToArray.join('; ')
			}
			d.assignedToString = assignedToString
			exportArray.push({
				'Case Number': d.jobNumber,
				'Date Created': convertToDateTimeShort(d.dateCreated),
				'Request Type': d.serviceType,
				'Paying Customer': d.site,
				'Work Order Number': d.clientName,
				'ETA': convertToDateShort(d.dateOfService) + ' ' + (d.eta !== undefined ? d.eta : ''),
				'Tech/Service Partner': assignedToString,
				'Status': d.serviceStatus,
				'Customer PO #': d.poNumber,
				'Region': d.region,
				'Billing Disposition': d.billingDisposition
			});
		})
		return (
			<Fragment>
				<TEHelmet {...meta} />
				<PanelWrapper>
					<Panel title="History"
						rightComponent={
							<div style={styles.flexBox}>
								<CsvDownload data={exportArray} style={styles.exportButton} filename="history_service_cases.csv">Export</CsvDownload>
						    </div>
						}
					>
						<div style={styles.tableContainer}>
							<ReactTable
								data={jobArray}
								columns={tableColumns}
								defaultPageSize={10}
								filterable
								defaultFilterMethod={customTableFilter}
								defaultSorted={[
									{
										id: 'jobNumber',
										desc: true,
									},
								]}
							/>
						</div>
					</Panel>
				</PanelWrapper>
			</Fragment>
		)
	}
}

History.propTypes = {}

History.defaultProps = {}

const mapStateToProps = (state) => {
	const { userModel } = state.Loading
	const { organizationUsers } = state.Admin.Organizations
	const jobArray = getJobHistoryArray(state)
	return { userModel, jobArray, organizationUsers }
}

export default connect(
	mapStateToProps,
	{ startWatchingJobsHistory, stopWatchingJobsHistory, startWatchingOrganization, stopWatchingOrganization }
)(Radium(History))
